import { SettingConst } from '../../types';

/**
 * Enable SDUI for web category pages
 */
export const ENABLE_SDUI_WEB_CATEGORY_PAGE_240724 =
  'ENABLE_SDUI_WEB_CATEGORY_PAGE_240724' as SettingConst<
    'ENABLE_SDUI_WEB_CATEGORY_PAGE_240724',
    boolean,
    'RETAILER' | 'RETAILER_HEAD_TAGS'
  >;
